import { render, staticRenderFns } from "./TheReviewASubmittedDeathRecord.vue?vue&type=template&id=94a6e27a&"
import script from "./TheReviewASubmittedDeathRecord.vue?vue&type=script&lang=js&"
export * from "./TheReviewASubmittedDeathRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports